import {makeAutoObservable, runInAction} from "mobx";
import {authAPI} from "./api";
import {sessionStore} from "@services/session";
import {navigateStore, routes} from "@services/navigateObserver/navigate.store";

export interface IUserData {
    username: string
    // email: string
    password: string
}

export interface IUserRegistrationData {
    email: string,
    password: string
    nickname: string
}

export interface IResponseUserData {
    id: number
    email: string
    token: string
}

export interface AuthMeI {
    authId: number | null
    email: string | null
    isAuth: boolean
}


class AuthStore {

    sessionStore

    signInData = {
        email: '',
        password: '',
        nickname: '',
        isCaptcha: false,
        isErrorSignIn: false
    }

    isLoading = true

    constructor() {
        makeAutoObservable(this);

        setTimeout(() => {
            this.sessionStore = sessionStore
        })

    }

    get hasAllowSignIn() {
        // const validEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.signInData.email)
        return this.signInData.nickname
            // && validEmail
            && this.signInData.password
            && !this.signInData.isCaptcha
    }

    setEmail = (email: string) => {
        this.signInData.email = email
    }

    setPassword = (password: string) => {
        this.signInData.password = password
    }

    setNickname = (nickname: string) => {
        this.signInData.nickname = nickname
    }

    clearErrorSignIn = () => {
        this.signInData.isErrorSignIn = false
    }

    login = async () => {
        try {
            const userData = {
                username: this.signInData.nickname,
                password: this.signInData.password,
            }
            const data = await authAPI.login(userData)

            this.sessionStore.setSession(data)

            runInAction(() => {
                this.signInData.isErrorSignIn = false
                this.signInData.isCaptcha = false
            })

            // this.setEmail('')
            this.setPassword('')
            this.setNickname('')

            navigateStore.navigate(routes.home)

            return data

        } catch (error) {
            console.log('error', error)
            await authAPI.fixIp()
            runInAction(() => {
                this.signInData.isErrorSignIn = true
                this.signInData.isCaptcha = true
            })
        }

    };

    checkIp = async () => {
        try {
            const data = await authAPI.checkIp()
            runInAction(() => {
                this.signInData.isCaptcha = data
                this.isLoading = false
            })
        } catch (e) {

        }
    }

    getStatusCheckedCaptcha = async (token) => {
        try {
            const data = await authAPI.getStatusCheckedCaptcha(token)
            if(data.status === 'ok') {
                runInAction(() => {
                    this.signInData.isCaptcha = false
                })
            }
            console.log(data)
        } catch (e) {
            if(!this.signInData.isCaptcha) {
                runInAction(() => {
                    this.signInData.isCaptcha = true
                })
            }
            console.log(e)
        }
    }
}

export const authStore = new AuthStore()